export default {
  totalCommentsText(state) {
    const count = state.totalComments
    return `${count} ${count === 0 || count > 1 ? 'Comments' : 'Comment'}`
  }
}
